import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { useSettings } from "../lib/hooks";
import { injectAnalytics } from "../lib/api";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);
  const { data: settings } = useSettings();

  useEffect(() => {
    const choice = localStorage.getItem("noor-cookie-consent");
    if (!choice) {
      const t = setTimeout(() => setVisible(true), 1200);
      return () => clearTimeout(t);
    }
    if (choice === "accepted" && settings) injectAnalytics(settings);
  }, [settings]);

  const decide = (value) => {
    localStorage.setItem("noor-cookie-consent", value);
    setVisible(false);
    if (value === "accepted" && settings) injectAnalytics(settings);
  };

  // While the banner floats over the page, reserve bottom space so it can
  // never cover form inputs or footer links at the bottom of a page.
  useEffect(() => {
    if (!visible) return undefined;
    const prev = document.body.style.paddingBottom;
    document.body.style.paddingBottom = "150px";
    return () => {
      document.body.style.paddingBottom = prev;
    };
  }, [visible]);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 24 }}
          transition={{ duration: 0.5 }}
          data-testid="cookie-consent-banner"
          className="fixed bottom-16 md:bottom-4 left-3 right-3 mx-auto md:mx-0 md:left-4 md:right-auto w-auto max-w-[300px] md:max-w-[340px] z-[60] bg-graphite text-white border border-white/15 p-4 shadow-2xl"
          role="dialog"
          aria-label="Cookie consent"
        >
          <p className="text-[10px] text-white/75 leading-snug">
            Essential cookies only unless you accept optional analytics.{" "}
            <Link to="/cookie-policy" className="underline underline-offset-2 hover:text-ember" data-testid="cookie-policy-link">
              Cookie Policy
            </Link>
          </p>
          <div className="flex gap-2 mt-3">
            <button
              onClick={() => decide("accepted")}
              data-testid="cookie-accept-button"
              className="flex-1 bg-ember hover:bg-emberdark text-white text-xs font-semibold py-2 transition-colors duration-300"
            >
              Accept
            </button>
            <button
              onClick={() => decide("rejected")}
              data-testid="cookie-reject-button"
              className="flex-1 border border-white/25 hover:border-white/60 text-white text-xs py-2 transition-colors duration-300"
            >
              Reject
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
